const locale = {
    en: {
        navbar_topping: {
            advicement: 'Suggestion',
        },
        nav: {
            search: {
                header: 'Search',
                buy: 'Buy',
                rent: 'Rent',
                new_property: 'New Property',
                property_agent: 'Property Agent',
                all: 'Find All',
            },
            investment: {
                header: 'Investment',
                property: 'Property',
                project: 'Project',
                token_marketplace: 'Token Marketplace',
            },
            professional_service: 'Professional Service',
            our_profile: {
                header: 'Our Profile',
                about_us: 'About Us',
                how_it_works: 'How it Works',
                faq: 'FAQ',
            },
            other: {
                header: 'Others',
                forum: 'Forum',
                plan_and_pricing: 'Buy Membership',
                blog: 'Blog',
            },
            advertise: {
                header: 'Advertise',
                sell: 'Sell',
                rent: 'Rent',
                new_property: 'New Property',
                professional: 'Professional',
            },
            login: 'Login',
            membership_area: 'Membership Area',
            professional_area: 'Professional Area',
            logout: {
                text: 'Logout',
                success: 'Logout successfully',
            },
            advicement: {
                title: 'Suggestion',
                success: 'Thank you for your advice',
                error: 'We are sorry, somethink when wrong, try again later',
                login_first: 'Please login first to submit advicement',
            },
        },
        memberarea: {
            home: 'Back Home',
            info: 'Basic Info',
            profile: 'My Profile',
            wallet: 'My Wallet',
            bank_account: 'My Bank Account',
            agent: 'Agent',
            agent_membership: 'Agent Membership',
            property_ads: 'My Property Ads',
            referral: 'Referral Comission',
            developer: 'Developer',
            developer_membership: 'Developer Membership',
            project_ads: 'My Project Ads',
            order: 'My Transactions',
            investment: 'Investment',
            my_investment: 'My Investments',
            token_marketplace: 'My Token Listing',
            professional: 'Professional',
            professional_membership: 'Professional Membership',
            business_detail: 'Business Detail',
            portfolio: 'My Portfolio',
            crowdfund_ads: 'My Crowdfund Ads',
            favorite: 'My Favorite',
            proposal: 'My Proposal',
            workspace: 'My Workspace',
            survey_status: 'My Survey Appointment',
            incoming_proposal: 'Incoming Proposal',
            service_progress: 'My Job Order',
        },
        memberarea_route: {
            'my-profile': 'My Profile',
            'my-membership': 'My Agent Membership',
            'my-dev-membership': 'My Dev Membership',
            'my-professional-membership': 'My Professional Membership',
            'my-order': 'My Transaction',
            'my-investment': 'My Investment',
            'my-investment-detail': 'Investment Detail',
            'my-investment-history': 'Investment History',
            'my-marketplace': 'My Token Listing',
            'my-property': 'My Property',
            'my-project': 'My Project',
            'edit-advertisement-property': 'Edit Property',
            'edit-advertisement-project': 'Edit Project',
            'my-favorite': 'My Favorite',
            'my-wallet': 'My Wallet',
            'my-bank-account': 'My Bank Account',
            'my-referral': 'My Referral',
            'my-proposal': 'My Proposal',
            'professional-workspace': 'My Workspace',
            'my-workspace-detail': 'Workspace Detail',
            'my-survey-status': 'My My Survey Appointment',
            'service-progress': 'My Job Order',
            'incoming-proposal': 'Incoming Proposal',
            'my-proposal-detail': 'Proposal Detail',
            'service-progress-detail': 'Status Pekerjaan',
            'my-business-detail': 'Add & Edit Portfolios',
        },
        detail_route: {
            'property-detail': 'Property Detail',
        },
        success_advice: 'Thank you for your advice',
        error_advice: 'We are sorry, somethink when wrong, try again later',
        search_placeholder: 'Type in location or name',
        ago: 'ago',
        no_notif: 'No notification yet',
        see_all_notif: 'See all',
        delete_all_notif: 'Delete all',
        notif_text: {
            from_admin: {
                broadcast: {
                    title: 'Propertigrab Info',
                },
            },
            from_system: {
                wallet_activity: {
                    title: 'Wallet Activity',
                    details: {
                        cashout_denied:
                            'Cashout {{AMOUNT}} (Rp) to {{BANK_NAME}} denied, because of {{REASON}}',
                        cashout_paid:
                            'Cashout {{AMOUNT}} (Rp) to {{BANK_NAME}} paid successfully',
                        adminUpdate: 'Cash balance was mutated {{AMOUNT}} (Rp) by Propertigrab',
                        adminTopup: 'Cash is added {{AMOUNT}} (Rp) to your wallet by Propertigrab',
                        topup: 'Topup {{AMOUNT}} (Rp) succesfully added to your wallet',
                        refund: 'Cash {{AMOUNT}} (Rp) succesfully refunded to your wallet',
                        referralPaid:
                            'As reward from user referral, cash {{AMOUNT}} (Rp) succesfully add to your wallet',
                        paid: 'Marketplace paid {{AMOUNT}} (Rp) succesfully added to your wallet',
                        ITORefund:
                            'Crowdfunding for "{{FUNDING_NAME}}" failed. Refund {{AMOUNT}} (Rp) has been added to your wallet',
                        paidForService:
                            'Service finished {{AMOUNT}} (Rp) succesfully added to your wallet',
                        refundAService:
                            'Service refunded {{AMOUNT}} (Rp) succesfully added to your wallet',
                        partialPaidForService:
                            'Service partially paid {{AMOUNT}} (Rp) succesfully added to your wallet',
                        refundDirectOrderService:
                            'Direct order {{AMOUNT}} (Rp) succesfully added to your wallet',
                        remitDirectOrderService:
                            'Direct order remitted {{AMOUNT}} (Rp) succesfully added to your wallet',
                        ITOBuy: 'Used {{AMOUNT}} (Rp) for buying initial token offering',
                        marketplaceBuy: 'Used {{AMOUNT}} (Rp) for buying token on marketplace',
                        marketplaceBuyFee:
                            'Used {{AMOUNT}} (Rp) for token on marketplace buying fee',
                        hireProfessional: 'Used {{AMOUNT}} (Rp) for hire a professional',
                        buyMembership: 'Used {{AMOUNT}} (Rp) to buy membership plan',
                        membershipVerified:
                            'Your membership "{{MEMBERSHIP_NAME}}" is now active. Enjoy your benefits!',
                        buyDirectOrderService:
                            'Used {{AMOUNT}} (Rp) to hire a professional (direct order)',
                    },
                },
                favorited_item_updated: {
                    title: 'Favorited Item Updated',
                    details: {
                        agent: 'Hi, your favorited property agent "{{NAME}}" just updated his/her profile, click if you want to check it out',
                        property:
                            'Hi, property that you favorited "{{NAME}}" have changed, you can check the update in the detail',
                        project:
                            'Hi, project that you favorited "{{NAME}}" have changed, you can check the update in the detail',
                        professional:
                            'Hi, professional that you favorited "{{NAME}}" have changed, you can check the update in the detail',
                        service:
                            'Hi, service that you favorited "{{NAME}}" have changed, you can check the update in the detail',
                    },
                },
                mark_as_favorite: {
                    title: 'Mark as Favorite by Other Member',
                    details: {
                        agent: 'Hi, your profile is mark as favorite by {{NAME}}',
                        property:
                            'Hi, your property "{{SOLUTION_NAME}}", is mark as favorite by {{NAME}}',
                        project:
                            'Hi, new properties project that you posted "{{SOLUTION_NAME}}", is mark as favorite by {{NAME}}',
                        professional: 'Hi, your business profile is mark as favorite by {{NAME}}',
                        service:
                            'Hi, your professional service "{{SERVICE_NAME}}", is mark as favorite by {{NAME}}',
                    },
                },
                solution_status_updated: {
                    title: 'Solution Status Updated',
                    details: {
                        proposed: '',
                        verified:
                            'Hi your solution "{{SOLUTION_NAME}}", have changed status to verified, it is currently listed, click this notif to check it',
                        denied: 'We are sorry your solution "{{SOLUTION_NAME}}", have been denied, if you feel this is incorrect please contact Propertigrab to clarify it',
                        expired:
                            'Hi your solution "{{SOLUTION_NAME}}", have been expired, you can extend again in membership area',
                    },
                },
                forum_activity: {
                    title: 'Forum Activity',
                    details: {
                        like_thread: 'Your thread "{{DESCRIPTION}}" liked by {{MEMBER}}',
                        like_comment: 'Your comment "{{DESCRIPTION}}" liked by {{MEMBER}}',
                        commented: '',
                    },
                },
                survei_request_client: {
                    title: 'My Request Survey',
                    details: {
                        direct: {
                            requested:
                                'Your request of survey for service "{{SERVICE_NAME}}", from "{{BUSINESS_NAME}}" have been notified to the professional',
                            accepted:
                                'Your request of survey for service "{{SERVICE_NAME}}", from "{{BUSINESS_NAME}}" have been accepted by the professional',
                            rejected:
                                'Your request of survey for service "{{SERVICE_NAME}}", from "{{BUSINESS_NAME}}" have been rejected by the professional',
                            canceled:
                                'Your request of survey for service "{{SERVICE_NAME}}", from "{{BUSINESS_NAME}}" have been successfully canceled',
                            done: 'Your request of survey for service "{{SERVICE_NAME}}", from "{{BUSINESS_NAME}}" have been marked as done',
                            notDone:
                                'Your request of survey for service "{{SERVICE_NAME}}", from "{{BUSINESS_NAME}}" have been marked as not done',
                        },
                        survei: {
                            requested:
                                'Your request for survey has been send to "{{BUSINESS_NAME}}", please wait for the professional to respond',
                            accepted:
                                'Your request for survey has been accepted by "{{BUSINESS_NAME}}"',
                            rejected:
                                'Your request for survey has been rejected by "{{BUSINESS_NAME}}"',
                            canceled:
                                'Your request for survey by "{{BUSINESS_NAME}}", has been successfully canceled',
                            done: 'Your request for survey by "{{BUSINESS_NAME}}", has been successfully mark as done',
                            notDone:
                                'Your request for survey by "{{BUSINESS_NAME}}", has been successfully mark as not done',
                        },
                        proposal: {
                            requested:
                                'Your request for proposal has been send to "{{BUSINESS_NAME}}", please wait for the professional to create the proposal',
                            accepted:
                                'Your request for proposal from "{{BUSINESS_NAME}}" has been accepted',
                            rejected:
                                'Your request for proposal from "{{BUSINESS_NAME}}" has been rejected',
                            canceled:
                                'Your request for proposal from "{{BUSINESS_NAME}}" has been successfully canceled',
                            done: 'Your request for proposal from "{{BUSINESS_NAME}}" has been successfully mark as done',
                            notDone:
                                'Your request for proposal from "{{BUSINESS_NAME}}" has been successfully mark as not done',
                        },
                    },
                },
                survei_request_professional: {
                    title: 'Request Survey Order',
                    details: {
                        direct: {
                            requested:
                                'New request for survey by "{{CLIENT_NAME}}" on "{{SERVICE_NAME}}"',
                            accepted:
                                'Accepted a survey request, please come on time for "{{SERVICE_NAME}}" survey by "{{CLIENT_NAME}}"',
                            rejected:
                                'Rejected a survey request, for "{{SERVICE_NAME}}" survey by "{{CLIENT_NAME}}"',
                            canceled:
                                'Client "{{CLIENT_NAME}}" have canceled a survey request, for "{{SERVICE_NAME}}"',
                            done: 'Client "{{CLIENT_NAME}}" have mark a survey request as done, for "{{SERVICE_NAME}}"',
                            notDone:
                                'Client "{{CLIENT_NAME}}" have mark a survey request as not done, for "{{SERVICE_NAME}}"',
                        },
                        survei: {
                            requested: 'New request for survey by "{{CLIENT_NAME}}"',
                            accepted:
                                'Accepted a survey request, please come on time for survey by "{{CLIENT_NAME}}"',
                            rejected: 'Rejected a survey request, for survey by "{{CLIENT_NAME}}"',
                            canceled: 'Client "{{CLIENT_NAME}}" have canceled a survey request',
                            done: 'Client "{{CLIENT_NAME}}" have mark a survey request as done',
                            notDone:
                                'Client "{{CLIENT_NAME}}" have mark a survey request as not done',
                        },
                        proposal: {
                            requested: 'New request for proposal by "{{CLIENT_NAME}}"',
                            accepted:
                                'Accepted a proposal request, please create a proposal for "{{CLIENT_NAME}}"',
                            rejected: 'Rejected a proposal request by "{{CLIENT_NAME}}"',
                            canceled: 'Client "{{CLIENT_NAME}}" have canceled a proposal request',
                            done: 'Client "{{CLIENT_NAME}}" have mark a proposal request as done',
                            notDone:
                                'Client "{{CLIENT_NAME}}" have mark a proposal request as not done',
                        },
                    },
                },
                direct_order_client: {
                    title: 'Direct Order Client',
                    details: {
                        Created:
                            'Hi, your order for service "{{SERVICE_NAME}}", from "{{BUSINESS_NAME}}" have been notified to the professional',
                        Cancel: 'Your order for service "{{SERVICE_NAME}}", from "{{BUSINESS_NAME}}" have been successfully canceled',
                        Accepted:
                            'Your order for service "{{SERVICE_NAME}}", from "{{BUSINESS_NAME}}" have been accepted by the professional',
                        StartWorking:
                            'The professional "{{BUSINESS_NAME}}", have started to work on service "{{SERVICE_NAME}}" that you ordered',
                        JobDone:
                            'The professional "{{BUSINESS_NAME}}", have finished to work on service "{{SERVICE_NAME}}" that you ordered',
                        Complained:
                            'You have successfully submited a complain for service "{{SERVICE_NAME}}", from "{{BUSINESS_NAME}}"',
                        Revised:
                            'The professional "{{BUSINESS_NAME}}", have revised the work on service "{{SERVICE_NAME}}" that you ordered',
                        Approved:
                            'Your order for service "{{SERVICE_NAME}}", from "{{BUSINESS_NAME}}" have been successfully approved',
                        Remitted:
                            'Your order for service "{{SERVICE_NAME}}", have been finished, the professional "{{BUSINESS_NAME}}"',
                        SettleByAdmin:
                            'Hi, your order for service "{{SERVICE_NAME}}", from "{{BUSINESS_NAME}}" have been mark as settle by admin',
                    },
                },
                direct_order_professional: {
                    title: 'Direct Order Professional',
                    details: {
                        Created:
                            'New direct order from "{{CLIENT_NAME}}" for service "{{SERVICE_NAME}}"',
                        Cancel: 'The direct order from "{{CLIENT_NAME}}" for service "{{SERVICE_NAME}}" have been canceled',
                        Accepted:
                            'The direct order from "{{CLIENT_NAME}}" for service "{{SERVICE_NAME}}" have been successfully accepted',
                        StartWorking:
                            'The direct order from "{{CLIENT_NAME}}" for service "{{SERVICE_NAME}}" have been successfully mark as start working',
                        JobDone:
                            'The direct order from "{{CLIENT_NAME}}" for service "{{SERVICE_NAME}}" have been successfully mark as job done',
                        Complained:
                            'New complain issued from "{{CLIENT_NAME}}" for service "{{SERVICE_NAME}}"',
                        Revised:
                            'The direct order from "{{CLIENT_NAME}}" for service "{{SERVICE_NAME}}" have been successfully mark as revised',
                        Approved:
                            'The direct order from "{{CLIENT_NAME}}" for service "{{SERVICE_NAME}}" have been approved',
                        Remitted:
                            'The direct order from "{{CLIENT_NAME}}" for service "{{SERVICE_NAME}}" have finished, and the fund have been transferred to your wallet',
                        SettleByAdmin:
                            'The direct order from "{{CLIENT_NAME}}" for service "{{SERVICE_NAME}}" have been successfully mark as settled by admin',
                    },
                },
                proposal_order_client: {
                    title: 'Proposal Order (Client)',
                    details: {
                        proposed:
                            'Hi "{{CLIENT_NAME}}", there is a new proposal from "{{BUSINESS_NAME}}"',
                    },
                },
                proposal_order_professional: {
                    title: 'Proposal Order (Professional)',
                    details: {
                        accepted:
                            'Hi "{{BUSINESS_NAME}}", your proposal has been accepted by "{{CLIENT_NAME}}", please prepare to start work',
                        rejected:
                            'Hi "{{BUSINESS_NAME}}", your proposal was rejected by "{{CLIENT_NAME}}"',
                    },
                },
            },
            from_user: {
                chat_message: {
                    title: 'New Messages',
                    created: 'New message from {{SENDER}}',
                },
            },
        },
        no_notifications_to_delete: 'No notifications to delete',
        notification_deleted_successfully: 'Notification deleted successfully',
        all_notifications_deleted_successfully: 'All notifications deleted successfully',
    },
    id: {
        navbar_topping: {
            advicement: 'Kritik & Saran',
        },
        nav: {
            search: {
                header: 'Cari',
                buy: 'Beli',
                rent: 'Sewa',
                new_property: 'Properti Baru',
                property_agent: 'Agen Properti',
                all: 'Temukan Semua',
            },
            investment: {
                header: 'Investasi',
                property: 'Properti',
                project: 'Project',
                token_marketplace: 'Token Marketplace',
            },
            professional_service: 'Jasa Profesional',
            our_profile: {
                header: 'Profile Kami',
                about_us: 'Tentang Kami',
                how_it_works: 'Cara Kerja',
                faq: 'FAQ',
            },
            other: {
                header: 'Lainnya',
                forum: 'Forum',
                plan_and_pricing: 'Beli Membership',
                blog: 'Blog',
            },
            advertise: {
                header: 'Pasang Iklan',
                sell: 'Jual',
                rent: 'Sewa',
                new_property: 'Properti Baru',
                professional: 'Profesional',
            },
            login: 'Login',
            membership_area: 'Area Member',
            professional_area: 'Area Professional',
            logout: {
                text: 'Logout',
                success: 'Berhasil logout',
            },
            advicement: {
                title: 'Kritik & Saran',
                success: 'Terima kasih untuk saran anda',
                error: 'Maaf, terjadi kesalahan teknis, coba lagi nanti',
                login_first: 'Mohon login terlebih dahulu sebelum mengirim saran',
            },
        },
        memberarea: {
            home: 'Ke Home',
            info: 'Tentang Saya',
            profile: 'Profile Saya',
            wallet: 'Dompet Saya',
            bank_account: 'Akun Bank Saya',
            agent: 'Info Agen',
            agent_membership: 'Keanggotaan Agen',
            property_ads: 'Iklan Properti Saya',
            referral: 'Komisi Referral',
            developer: 'Info Developer',
            developer_membership: 'Keanggotaan Developer',
            project_ads: 'Iklan Project Saya',
            order: 'Pesanan Saya',
            investment: 'Investasi',
            my_investment: 'Investasi Saya',
            token_marketplace: 'Listing Token Saya',
            professional: 'Profesional',
            professional_membership: 'Keanggotaan Penyedia Jasa',
            business_detail: 'Detail Bisnis',
            portfolio: 'Portfolio Saya',
            crowdfund_ads: 'Iklan Crowdfund Saya',
            favorite: 'Favorit Saya',
            proposal: 'Proposal Saya',
            workspace: 'Workspace Saya',
            survey_status: 'Janji Survei Saya',
            incoming_proposal: 'Penawaran Masuk',
            service_progress: 'Pesanan Jasa Saya',
        },
        memberarea_route: {
            'my-profile': 'Profil Saya',
            'my-membership': 'Keanggotaan Agen',
            'my-dev-membership': 'Keanggotaan Dev',
            'my-professional-membership': 'Keanggotaan Penyedia Jasa',
            'my-order': 'Pesanan Saya',
            'my-investment': 'Investasi Saya',
            'my-investment-detail': 'Detail Investasi',
            'my-investment-history': 'Riwayat Investasi',
            'my-marketplace': 'Listing Token Saya',
            'my-property': 'Properti Saya',
            'my-project': 'Proyek Saya',
            'edit-advertisement-property': 'Ubah Info Properti',
            'edit-advertisement-project': 'Ubah Info Proyek',
            'my-favorite': 'Favorit Saya',
            'my-wallet': 'Dompet Saya',
            'my-bank-account': 'Akun Bank Saya',
            'my-referral': 'Referal Saya',
            'my-proposal': 'Proposal Saya',
            'professional-workspace': 'Workspace Saya',
            'my-workspace-detail': 'Detail Workspace',
            'my-survey-status': 'Janji Survei Saya',
            'service-progress': 'Pesanan Jasa Saya',
            'incoming-proposal': 'Proposal Masuk',
            'my-proposal-detail': 'Detail Proposal',
            'service-progress-detail': 'Status Pekerjaan',
            'my-business-detail': 'Tambah & Ubah Portofolio',
        },
        detail_route: {
            'property-detail': 'Detail Properti',
        },
        success_advice: 'Terima kasih untuk saran anda',
        error_advice: 'Maaf, terjadi kesalahan teknis, coba lagi nanti',
        search_placeholder: 'Ketik lokasi atau nama',
        ago: 'lalu',
        no_notif: 'belum ada notification',
        see_all_notif: 'Lihat selengkapnya',
        delete_all_notif: 'Hapus semua',
        notif_text: {
            from_admin: {
                broadcast: {
                    title: 'Info dari Propertigrab',
                },
            },
            from_system: {
                wallet_activity: {
                    title: 'Aktifitas Wallet',
                    details: {
                        cashout_denied:
                            'Pencairan dana sebesar {{AMOUNT}} (Rp) ke bank {{BANK_NAME}} ditolak, karena {{REASON}}',
                        cashout_paid:
                            'Pencairan dana sebesar {{AMOUNT}} (Rp) ke bank {{BANK_NAME}} berhasil dilakukan',
                        adminUpdate: 'Saldo diubah sebanyak {{AMOUNT}} (Rp) oleh Propertigrab',
                        adminTopup: 'Saldo ditambahkan sebanyak {{AMOUNT}} (Rp) oleh Propertigrab',
                        topup: 'Topup sebesar {{AMOUNT}} (Rp) berhasil ditambahkan ke wallet',
                        refund: 'Cash sebesar {{AMOUNT}} (Rp) berhasil di-refund ke wallet',
                        referralPaid:
                            'Sebagai hadiah referral, cash sebesar {{AMOUNT}} (Rp) berhasil ditambahkan ke wallet',
                        paid: 'Marketplace paid {{AMOUNT}} (Rp) berhasil ditambahkan ke wallet',
                        ITORefund:
                            'Crowdfunding "{{FUNDING_NAME}}" gagal didanai. Refund sebesar {{AMOUNT}} (Rp) telah ditambahkan ke wallet',
                        paidForService:
                            'Jasa selesai dilakukan, dana sebesar {{AMOUNT}} (Rp) berhasil ditambahkan ke wallet',
                        refundAService:
                            'Jasa di-refund, dana sebesar {{AMOUNT}} (Rp) berhasil ditambahkan ke wallet',
                        partialPaidForService:
                            'Jasa dibayarkan sebagian, dana sebesar {{AMOUNT}} (Rp) berhasil ditambahkan ke wallet',
                        refundDirectOrderService:
                            'Jasa langsung di-refund, dana sebesar {{AMOUNT}} (Rp) berhasil ditambahkan ke wallet',
                        remitDirectOrderService:
                            'Jasa langsung diselesaikan, dana sebesar {{AMOUNT}} (Rp) berhasil ditambahkan ke wallet',
                        ITOBuy: 'Memakai {{AMOUNT}} (Rp), untuk membeli token di initial token offering',
                        marketplaceBuy:
                            'Memakai {{AMOUNT}} (Rp), untuk membeli token di marketplace',
                        marketplaceBuyFee:
                            'Memakai {{AMOUNT}} (Rp), untuk biaya membeli token di marketplace',
                        hireProfessional:
                            'Memakai {{AMOUNT}} (Rp), untuk menyewa jasa professional',
                        buyMembership: 'Memakai {{AMOUNT}} (Rp), untuk membeli membership',
                        membershipVerified:
                            'Membership "{{MEMBERSHIP_NAME}}" kamu sudah aktif. Selamat menikmati benefitnya!',
                        buyDirectOrderService:
                            'Memakai {{AMOUNT}} (Rp), untuk menyewa jasa professional (jasa langsung)',
                    },
                },
                favorited_item_updated: {
                    title: 'Update dari Favorite',
                    details: {
                        agent: 'Halo, agen property favorit mu "{{NAME}}" baru saja mengubah profile-nya, click di sini untuk melihat lebih lanjut',
                        property:
                            'Hi, properti yang kamu favoritkan "{{NAME}}" ada perubahan, kamu bisa periksa perubahannya di halaman detail',
                        project:
                            'Hi, terdapat perubahan data untuk project yang kamu favoritkan "{{NAME}}", kamu bisa periksa perubahannya di halaman detail',
                        professional:
                            'Hi, terdapat perubahan data untuk professional yang kamu favoritkan "{{NAME}}", kamu bisa periksa perubahannya di halaman detail',
                        service:
                            'Hi, terdapat perubahan data untuk jasa professional yang kamu favoritkan "{{NAME}}", kamu bisa periksa perubahannya di halaman detail',
                    },
                },
                mark_as_favorite: {
                    title: 'Difavoritkan Member Lain',
                    details: {
                        agent: 'Hi, profil mu di-favoritkan oleh {{NAME}}',
                        property:
                            'Hi, properti yang kamu upload "{{SOLUTION_NAME}}", difavoritkan oleh {{NAME}}',
                        project:
                            'Hi, proyek properti baru yang kamu posting "{{SOLUTION_NAME}}", difavoritkan oleh {{NAME}}',
                        professional: 'Hi, profil bisnis mu difavoritkan oleh {{NAME}}',
                        service:
                            'Hi, jasa yang kamu tawarkan "{{SERVICE_NAME}}", difavoritkan oleh {{NAME}}',
                    },
                },
                solution_status_updated: {
                    title: 'Status Iklan Terbaru',
                    details: {
                        proposed: '',
                        verified:
                            'Hi iklan kamu "{{SOLUTION_NAME}}", sudah ter-verifikasi dan muncul di listing iklan, klik di sini untuk melihatnya',
                        denied: 'Maaf iklan kamu "{{SOLUTION_NAME}}", ditolak, bila merasa ini adalah kesalahan kamu dapat mengontak Propertigrab untuk klarifikasi',
                        expired:
                            'Hi iklan kamu "{{SOLUTION_NAME}}", sudah expired, kamu dapat memperpanjang iklan ini di membership area',
                    },
                },
                forum_activity: {
                    title: 'Aktifitas Forum',
                    details: {
                        like_thread: 'Thread mu "{{DESCRIPTION}}" disukai oleh {{MEMBER}}',
                        like_comment: 'Komentar mu "{{DESCRIPTION}}" disukai oleh {{MEMBER}}',
                        commented: '',
                    },
                },
                survei_request_client: {
                    title: 'Permintaan Survei Saya',
                    details: {
                        direct: {
                            requested:
                                'Permintaan survei Anda untuk layanan "{{SERVICE_NAME}}", dari "{{BUSINESS_NAME}}" telah diberitahukan kepada penyedia jasa',
                            accepted:
                                'Permintaan survei Anda untuk layanan "{{SERVICE_NAME}}", dari "{{BUSINESS_NAME}}" telah disetujui oleh penyedia jasa',
                            rejected:
                                'Permintaan survei Anda untuk layanan "{{SERVICE_NAME}}", dari "{{BUSINESS_NAME}}" telah ditolak oleh penyedia jasa',
                            canceled:
                                'Permintaan survei Anda untuk layanan "{{SERVICE_NAME}}", dari "{{BUSINESS_NAME}}" telah berhasil dibatalkan',
                            done: 'Permintaan survei Anda untuk layanan "{{SERVICE_NAME}}", dari "{{BUSINESS_NAME}}" telah ditandai selesai',
                            notDone:
                                'Permintaan survei Anda untuk layanan "{{SERVICE_NAME}}", dari "{{BUSINESS_NAME}}" telah ditandai tidak selesai',
                        },
                        survei: {
                            requested:
                                'Permintaan survei Anda telah dikirim ke "{{BUSINESS_NAME}}", harap tunggu hingga profesional memberikan tanggapan',
                            accepted:
                                'Permintaan survei Anda telah diterima oleh "{{BUSINESS_NAME}}"',
                            rejected:
                                'Permintaan survei Anda telah ditolak oleh "{{BUSINESS_NAME}}"',
                            canceled:
                                'Permintaan survei Anda oleh "{{BUSINESS_NAME}}", telah berhasil dibatalkan',
                            done: 'Permintaan survei Anda oleh "{{BUSINESS_NAME}}", telah berhasil ditandai sebagai selesai',
                            notDone:
                                'Permintaan survei Anda oleh "{{BUSINESS_NAME}}", telah berhasil ditandai sebagai belum selesai',
                        },
                        proposal: {
                            requested:
                                'Permintaan proposal Anda telah dikirim ke "{{BUSINESS_NAME}}", harap tunggu hingga profesional membuat proposal',
                            accepted:
                                'Permintaan proposal Anda dari "{{BUSINESS_NAME}}" telah diterima',
                            rejected:
                                'Permintaan proposal Anda dari "{{BUSINESS_NAME}}" telah ditolak',
                            canceled:
                                'Permintaan proposal Anda dari "{{BUSINESS_NAME}}" telah berhasil dibatalkan',
                            done: 'Permintaan proposal Anda dari "{{BUSINESS_NAME}}" telah berhasil ditandai sebagai selesai',
                            notDone:
                                'Permintaan proposal Anda dari "{{BUSINESS_NAME}}" telah berhasil ditandai sebagai belum selesai',
                        },
                    },
                },
                survei_request_professional: {
                    title: 'Permintaan Survei',
                    details: {
                        direct: {
                            requested:
                                'Permintaan survei baru oleh "{{CLIENT_NAME}}" di "{{SERVICE_NAME}}"',
                            accepted:
                                'Menerima permintaan survei, silakan datang tepat waktu untuk survei "{{SERVICE_NAME}}" oleh "{{CLIENT_NAME}}"',
                            rejected:
                                'Menolak permintaan survei, untuk survei "{{SERVICE_NAME}}" oleh "{{CLIENT_NAME}}"',
                            canceled:
                                'Klien "{{CLIENT_NAME}}" telah membatalkan permintaan survei, untuk "{{SERVICE_NAME}}"',
                            done: 'Klien "{{CLIENT_NAME}}" telah menandai permintaan survei sebagai selesai, untuk "{{SERVICE_NAME}}"',
                            notDone:
                                'Klien "{{CLIENT_NAME}}" telah menandai permintaan survei sebagai belum selesai, untuk "{{SERVICE_NAME}}"',
                        },
                        pengawasan: {
                            diminta: 'Permintaan survei baru oleh "{{CLIENT_NAME}}"',
                            accepted:
                                'Menerima permintaan survei, harap datang tepat waktu untuk survei oleh "{{CLIENT_NAME}}"',
                            rejected:
                                'Menolak permintaan survei, untuk survei oleh "{{CLIENT_NAME}}"',
                            canceled: 'Klien "{{CLIENT_NAME}}" telah membatalkan permintaan survei',
                            done: 'Klien "{{CLIENT_NAME}}" telah menandai permintaan survei sebagai selesai',
                            notDone:
                                'Klien "{{CLIENT_NAME}}" telah menandai permintaan survei sebagai belum selesai',
                        },
                        usulan: {
                            requested: 'Permintaan proposal baru dari "{{CLIENT_NAME}}"',
                            accepted:
                                'Menerima permintaan proposal, silakan buat proposal untuk "{{CLIENT_NAME}}"',
                            rejected: 'Menolak permintaan proposal dari "{{CLIENT_NAME}}"',
                            canceled:
                                'Klien "{{CLIENT_NAME}}" telah membatalkan permintaan proposal',
                            done: 'Klien "{{CLIENT_NAME}}" telah menandai permintaan proposal sebagai selesai',
                            notDone:
                                'Klien "{{CLIENT_NAME}}" telah menandai permintaan proposal sebagai belum selesai',
                        },
                    },
                },
                direct_order_client: {
                    title: 'Jasa Segera (Klien)',
                    details: {
                        Created:
                            'Hai, pesanan Anda untuk layanan "{{SERVICE_NAME}}", dari "{{BUSINESS_NAME}}" telah diberitahukan kepada profesional',
                        Cancel: 'Pesanan Anda untuk layanan "{{SERVICE_NAME}}", dari "{{BUSINESS_NAME}}" telah berhasil dibatalkan',
                        Accepted:
                            'Pesanan Anda untuk layanan "{{SERVICE_NAME}}", dari "{{BUSINESS_NAME}}" telah diterima oleh profesional',
                        StartWorking:
                            '"{{BUSINESS_NAME}}" profesional, sudah mulai mengerjakan layanan "{{SERVICE_NAME}}" yang Anda pesan',
                        JobDone:
                            'Profesional "{{BUSINESS_NAME}}", telah selesai mengerjakan layanan "{{SERVICE_NAME}}" yang Anda pesan',
                        Complained:
                            'Komplain anda untuk layanan "{{SERVICE_NAME}}", dari "{{BUSINESS_NAME}}" telah berhasil diteruskan',
                        Revised:
                            'Profesional "{{BUSINESS_NAME}}", telah merevisi pekerjaan pada layanan "{{SERVICE_NAME}}" yang Anda pesan',
                        Approved:
                            'Pesanan Anda untuk layanan "{{SERVICE_NAME}}", dari "{{BUSINESS_NAME}}" telah berhasil disetujui',
                        Remitted:
                            'Pesanan Anda untuk layanan "{{SERVICE_NAME}}", telah selesai, profesional "{{BUSINESS_NAME}}"',
                        SettleByAdmin:
                            'Hai, pesanan Anda untuk layanan "{{SERVICE_NAME}}", dari "{{BUSINESS_NAME}}" telah ditandai sebagai diselesaikan oleh admin',
                    },
                },
                direct_order_professional: {
                    title: 'Jasa Segera (Profesional)',
                    details: {
                        Created:
                            'Pesanan langsung baru dari "{{CLIENT_NAME}}" untuk layanan "{{SERVICE_NAME}}"',
                        Cancel: 'Pesanan langsung dari "{{CLIENT_NAME}}" untuk layanan "{{SERVICE_NAME}}" telah dibatalkan',
                        Accepted:
                            'Pesanan langsung dari "{{CLIENT_NAME}}" untuk layanan "{{SERVICE_NAME}}" telah berhasil diterima',
                        StartWorking:
                            'Pesanan langsung dari "{{CLIENT_NAME}}" untuk layanan "{{SERVICE_NAME}}" telah berhasil ditandai sebagai mulai dikerjakan',
                        JobDone:
                            'Pesanan langsung dari "{{CLIENT_NAME}}" untuk layanan "{{SERVICE_NAME}}" telah berhasil ditandai sebagai pekerjaan selesai',
                        Complained:
                            'Keluhan baru dikeluarkan oleh "{{CLIENT_NAME}}" untuk layanan "{{SERVICE_NAME}}"',
                        Revised:
                            'Pesanan langsung dari "{{CLIENT_NAME}}" untuk layanan "{{SERVICE_NAME}}" telah berhasil ditandai sebagai direvisi',
                        Approved:
                            'Pesanan langsung dari "{{CLIENT_NAME}}" untuk layanan "{{SERVICE_NAME}}" telah disetujui',
                        Remitted:
                            'Pesanan langsung dari "{{CLIENT_NAME}}" untuk layanan "{{SERVICE_NAME}}" telah selesai, dan dana telah ditransfer ke dompet Anda',
                        SettleByAdmin:
                            'Pesanan langsung dari "{{CLIENT_NAME}}" untuk layanan "{{SERVICE_NAME}}" telah berhasil ditandai sebagai diselesaikan oleh admin',
                    },
                },
                proposal_order_client: {
                    title: 'Jasa Proposal (Klien)',
                    details: {
                        proposed: 'Hi {{CLIENT_NAME}}, ada proposal baru dari {{BUSINESS_NAME}}',
                    },
                },
                proposal_order_professional: {
                    title: 'Jasa Proposal (Profesional)',
                    details: {
                        accepted:
                            'Hi {{BUSINESS_NAME}}, proposal kamu sudah diterima oleh {{CLIENT_NAME}}, harap persiapkan untuk memulai pekerjaan',
                        rejected:
                            'Hi {{BUSINESS_NAME}}, proposal kamu ditolak oleh {{CLIENT_NAME}}',
                    },
                },
            },
            from_user: {
                chat_message: {
                    title: 'Pesan Baru',
                    created: 'Pesan baru dari {{SENDER}}',
                },
            },
        },
        no_notifications_to_delete: 'Tidak ada notifikasi yang dihapus',
        notification_deleted_successfully: 'Notifikasi berhasil di hapus',
        all_notifications_deleted_successfully: 'Semua notifikasi berhasil dihapus',
    },
};

export default locale;
